import { render, staticRenderFns } from "./BulkCreateTagModal.vue?vue&type=template&id=4b450575"
import script from "./BulkCreateTagModal.vue?vue&type=script&lang=ts"
export * from "./BulkCreateTagModal.vue?vue&type=script&lang=ts"
import style0 from "./BulkCreateTagModal.vue?vue&type=style&index=0&id=4b450575&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports